import { createSelector } from 'reselect';
import type { RootState } from 'reducers/index';
import { Status, PlacecardGuestListState, SORT } from 'cards/reducers/placecardGuestList/types';

export const getPlacecardGuestListState = (state: RootState): PlacecardGuestListState | null =>
  state.cards.placecardGuestList;

export const getPlacecardGuestListStatus = createSelector(
  getPlacecardGuestListState,
  state => state?.status || Status.INIT
);

export const getPlacecardGuestList = createSelector(
  getPlacecardGuestListState,
  state => state?.guestList || null
);

export const getPlacecardGuestListSortBy = createSelector(
  getPlacecardGuestListState,
  state => state?.sortBy || { primary: '', name: SORT.ASC, table: SORT.ASC }
);

export const getPlacecardGuestListEdit = createSelector(
  getPlacecardGuestListState,
  state => state?.edit || null
);

export const getPlacecardGuestListPreviewGuestUuid = createSelector(
  getPlacecardGuestListState,
  state => state?.previewGuest || null
);
